<template>
  <div class="account-wrap">
    <div class="inner-container">
      <div class="bg-white final-receipt-page section-gap">
        <div class="account-info">
          <div class="container grid-list-xl">
            <div class="layout justify-start mt-0 mb-4 mx-0">
              <div class="login-user-img">
                <img src="\static\images\user.svg" width="70" alt="Active User" />
              </div>
              <div class="px-4">
                <h4>{{profileTabSection.Hi_Label}} {{loginDetails.name}}</h4>
                <div class="text-muted text-xl">{{loginDetails.loginId}}</div>
                <!-- <<h5 class="text-muted text-xl">{{loginDetails.name}}</h5> -->
              </div>
            </div>

            <v-layout row wrap fill-height profile-list>
              <v-flex xs12 sm12 md4 lg3 xl2 user-nav-list px-0>
                <div class="emb-card account-block fill-height py-4">
                  <template>
                    <v-list
                      v-for="(cateogary,index) in profileTabSection.Profile_Tab_List"
                      :key="cateogary.name"
                      class="py-0 text-center"
                    >
                      <v-list-item @click="onTabChange(index)" :to="cateogary.Tab_Path">
                        <v-list-item-action class="ma-0">
                          <v-icon>{{cateogary.Tab_Icon}}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content class="py-0 text-left">
                          <v-list-item-title>
                            <span>{{cateogary.Tab_Title}}</span>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </template>
                </div>
              </v-flex>
              <v-flex xs12 sm12 md8 lg9 xl9 user-content-wrapper>
                <div v-for="(option,key,index) in settings" :key="key">
                  <router-view v-if="index == selectedTab"></router-view>
                </div>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import gettingRestClientObject from "../../../services/utils/cms-helper";
export default {
  computed: {
    ...mapGetters(["rtlLayout", "selectedLocale"]),
  },
  data() {
    return {
      loginDetails: "",
      cmsRequestFunctions: null,
      profileTabSection: "",
      settings: {
        orderHistory: [
          {
            title: "Order History",
            icon: "history",
            path: "/account/order-history",
            id: "orderHistory",
          },
        ],
        profile: [
          {
            title: "Profile",
            icon: "account_circle",
            path: "/account/profile",
            id: "profile",
          },
        ],
        address: [
          {
            title: "Addresses",
            icon: "location_on",
            path: "/account/address",
            id: "addresses",
          },
        ],
        // cards: [
        //   {
        //     title: "Saved Cards",
        //     icon: "credit_card",
        //     path: "/account/cards",
        //     id: "cards"
        //   }
        // ],
        newsletter: [
          {
            title: "Newsletter",
            icon: "credit_card",
            path: "/account/newsletter",
            id: "newsletter",
          },
        ],
      },
      selectedTab: 0,
    };
  },
  watch: {
    selectedLocale: function () {
      this.getData();
    },
  },
  mounted() {
    this.cmsRequestFunctions = gettingRestClientObject();
    this.getData();
  },
  methods: {
    onTabChange(key) {
      this.selectedTab = key;
    },
    getData: function () {
      var self = this;

      var language = localStorage.Language ? localStorage.Language : "en";
      var user = localStorage.getItem("embryo");
      var userData = JSON.parse(user);

      //self.userdata=self.user.user_data;

      // var userProfile = self.cmsRequestFunctions.pluck(
      //             "user_data",
      //           self.user
      //           );
      // console.log(userData);
      self.loginDetails = userData.user_data;
      // console.log(self.loginDetails);
      var config = {
        pageType: "Template/",
        pageUrl: "09 Profile/09 Profile/09 Profile.ftl",
        lang: language,

        successCallback: function (response) {
          var res = response.data;
          if (res.area_List) {
            var profilrTabArea = self.cmsRequestFunctions.pluck(
              "Profile_Tab_Section",
              res.area_List
            );
            self.profileTabSection = self.cmsRequestFunctions.getAllMapData(
              profilrTabArea[0].component
            );
          }
        },
        errorCallback: function (error) {
          console.log(error);
        },
      };
      this.cmsRequestFunctions.cmsRequest(config, language);
    },
  },
};
</script>
